import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
  PreEnrollmentInviteCreateRequestDTO,
  PreEnrollmentInviteDTO,
  PreEnrollmentInviteList,
  PreEnrollmentInviteUpdateRequestDTO,
} from "./invite-interface";

import {
  PreEnrollmentInvite_Create,
  PreEnrollmentInvite_Update,
  PreEnrollmentInvite_Delete,
  PreEnrollmentInvite_ReadByModule,
  PreEnrollmentInvite_ReadByMobileNo,
  PreEnrollmentInvite_CreateBulk,
} from "src/app/GlobalVariable";

@Injectable({
  providedIn: "root",
})
export class InviteService {
  constructor() {}

  http = inject(HttpClient);

  PreEnrollmentInvite_Create(
    data: PreEnrollmentInviteCreateRequestDTO,
  ): Observable<PreEnrollmentInviteDTO> {
    return this.http.post<PreEnrollmentInviteDTO>(
      PreEnrollmentInvite_Create,
      data,
    );
  }

  PreEnrollmentInvite_Update(
    data: PreEnrollmentInviteUpdateRequestDTO,
  ): Observable<PreEnrollmentInviteDTO> {
    return this.http.post<PreEnrollmentInviteDTO>(
      PreEnrollmentInvite_Update,
      data,
    );
  }

  PreEnrollmentInvite_Delete(data: any): Observable<void> {
    return this.http.post<void>(PreEnrollmentInvite_Delete, data);
  }

  PreEnrollmentInvite_ReadByModule(
    data: any,
  ): Observable<PreEnrollmentInviteList> {
    return this.http.post<PreEnrollmentInviteList>(
      PreEnrollmentInvite_ReadByModule,
      data,
    );
  }

  PreEnrollmentInvite_ReadByMobileNo(
    data: any,
  ): Observable<PreEnrollmentInviteDTO> {
    return this.http.post<PreEnrollmentInviteDTO>(
      PreEnrollmentInvite_ReadByMobileNo,
      data,
    );
  }

  PreEnrollmentInvite_CreateBulk(data: any): Observable<any> {
    return this.http.post<any>(PreEnrollmentInvite_CreateBulk, data);
  }
}
